import "@deltasge/marauders-map/lib/utils/string.extensions";

import React, { FC, useEffect, useRef, useState } from "react";
import { EChatType, IChat, IUser } from "@deltasge/marauders-map";

import { Grid, Paper, Typography } from "@mui/material";

import { Avatar } from "components/Avatar";
import { ChatImage } from "./components/ChatImage";
import { ChatDocument } from "./components/ChatDocument";
import { ChatVideo } from "./components/ChatVideo";
import { ChatAudio } from "./components/ChatAudio";
import { ChatUserName } from "./components/ChatUserName";
import { ChatTimeViewer } from "./components/ChatTimeViewer";
import { ChatText } from "./components/ChatText";

export const ChatItem: FC<{
  chat: IChat;
  user?: IUser;
  isMe: boolean;
}> = ({ chat, user, isMe }) => {
  let alignSelf: string | undefined = !isMe ? "start" : "end";
  if (chat.chatType == EChatType.Info) alignSelf = undefined;

  const refChatItem = useRef<HTMLDivElement | null>(null);
  const [width, setWidth] = useState<number>();

  useEffect(() => {
    if (refChatItem.current && chat.chatType != EChatType.Image) {
      setWidth(refChatItem.current.clientWidth - 8 - 16 - 40);
    }
  }, [chat.chatType]);

  return (
    <Grid item alignSelf={alignSelf} sx={{ mb: 1 }} ref={refChatItem}>
      <Grid container flexWrap="nowrap">
        {!isMe && chat.chatType != EChatType.Info && (
          <Grid item xs="auto">
            <Avatar
              src={user?.photoUrl ?? undefined}
              displayName={user?.displayName ?? undefined}
            />
          </Grid>
        )}
        {chat.chatType != EChatType.Info && (
          <Grid item>
            <Paper
              sx={{
                mr: 0.5,
                ml: 0.5,
                p: 1,
                background: (theme) =>
                  isMe ? theme.palette.primary.main : undefined,
                textAlign: isMe ? "right" : "left",
                minWidth: width,
              }}
              variant="outlined"
              elevation={0}
            >
              {!isMe && (
                <ChatUserName name={user?.displayName || user?.nome || ""} />
              )}
              {chat.chatType == EChatType.Image && (
                <ChatImage src={chat.context} />
              )}
              {chat.chatType == EChatType.Attachment && (
                <ChatDocument src={chat.context} />
              )}
              {chat.chatType == EChatType.Video && (
                <ChatVideo src={chat.context} />
              )}
              {chat.chatType == EChatType.Audio && (
                <ChatAudio src={chat.context} />
              )}
              {chat.chatType == EChatType.Text && (
                <ChatText isMe={isMe} text={chat.context} />
              )}
              <ChatTimeViewer
                createdAt={chat.createdAt?.toString() ?? ""}
                isMe={isMe}
                send={chat.delivered.length == 1}
                viewed={chat.delivered.length > 1}
                wait={chat.delivered.length == 0}
              />
            </Paper>
          </Grid>
        )}
        {isMe && chat.chatType != EChatType.Info && (
          <Grid item>
            <Avatar
              src={user?.photoUrl ?? undefined}
              displayName={user?.displayName ?? undefined}
            />
          </Grid>
        )}
        {chat.chatType == EChatType.Info && (
          <Grid
            item
            component={Paper}
            variant="outlined"
            elevation={0}
            sx={{
              flex: 1,
              textAlign: "center",
            }}
          >
            <Typography
              variant="caption"
              sx={(theme) => ({
                color: isMe ? theme.palette.primary.main : "inherit",
              })}
            >
              {chat.context}
            </Typography>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
